<template>
  <div id="app">   
    <div class="containerFluid">
      <div class="containerm">
        <img src="https://www.lefisc.com.br/monitoramentoncm/img/logo.png"  alt="" width="120w" height="25vh" @click="irPaginaInicial()"> <router-link to="/tv" class="aOi">TV Lefisc</router-link>
      </div>
    </div>
    <transition name="transicao-pagina">
      <router-view class="route-view" />
    </transition>    
  </div>
</template>
<script>


export default {
  name: 'App',
   methods:{
     irPaginaInicial(){
       location.href="https://www.lefisc.com.br/"
     }
   }
}
</script>

<style>
#app{
  min-height:100%;
  position:relative;
}
a.aOi:hover{
  text-decoration: none;
  color:#000;
}
html,body{
  scroll-behavior: smooth;
}
::-webkit-scrollbar {
  width: 13px;
  transition: 0.5s all;
}
::-webkit-scrollbar-thumb {
  background: rgb(165, 164, 164); 
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgb(82, 81, 81); 
}
html, body {height:100%;}
body{  
  box-sizing: border-box;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerFluid{
  background: #fff;
  margin-bottom: 35px;
}
.containerm{
  margin:0 auto;
  max-width: 1160px;
  padding:18px 0px;
  display: flex;
  align-items: center;
}
.containerm a{
  margin-left:25px;
  font-weight: 700;
  color: #383838;
  font-size: 18px;
  position: relative;
}
.containerm img{
  position: relative;
  cursor: pointer;
}
.containerm a::before{
  content: '';
  position: absolute;
  border-left:1px solid rgba(0,0,0,.5);  
  height: 27px;
  left: -10px;
}
body{
  background: #eff3f5;
}
li{
  position: relative;
}
li.active a{
  color: #383838;
}
li.active a::after{
  content: '';
  position: absolute;
  left:-3px;
  top:13px;  
  width: 1px;
  height: 25px;
  background: #000;
  border-left: .7px solid grey;
}
.transicao-pagina-enter {
  opacity: 0;
}

.transicao-pagina-enter-to {
  opacity: 1;
}

.transicao-pagina-enter-active {
  transition: opacity 1s;
}

.transicao-pagina-leave {
  opacity: 0;
}

.transicao-pagina-leave-to {
  opacity: 1;
}

.transicao-pagina-leave-active {
  transition: opacity 1s;
}
</style>
